import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { bool, func, object } from 'prop-types';
import { ButtonStyled } from '@nike/nike-design-system-components';

import Modal from '../../../modal/Modal';

import { deleteProductContractGroup } from '../actions';

const DeleteContractGroupModal = ({ isOpen, closeModal, contractGroup, deleteProductContractGroup }) => {
  const history = useHistory();

  const handleDelete = async toggleIsLoading => {
    toggleIsLoading(true, 'Deleting product contract group...');

    if (await deleteProductContractGroup({ productContractGroupId: contractGroup.id })) {
      history.push('/productContractGroups');
    }

    toggleIsLoading(false);
    closeModal();
  };

  return (
    <Modal
      closeModal={closeModal}
      isOpen={isOpen}
      content={() => 'Are you sure you want to delete this product contract group?'}
      title='Confirm Deletion'
      footer={({ isLoading, toggleIsLoading }) => (
        <>
          <ButtonStyled type='button' size='small' onClick={() => handleDelete(toggleIsLoading)} disabled={isLoading}>
            Delete
          </ButtonStyled>
          <ButtonStyled
            type='button'
            size='small'
            appearance='secondary'
            background='light'
            onClick={closeModal}
            disabled={isLoading}
          >
            Cancel
          </ButtonStyled>
        </>
      )}
    />
  );
};

DeleteContractGroupModal.propTypes = {
  closeModal: func.isRequired,
  isOpen: bool.isRequired,
  contractGroup: object.isRequired,
  deleteProductContractGroup: func.isRequired
};

export default connect(null, { deleteProductContractGroup })(DeleteContractGroupModal);
